import { render, staticRenderFns } from "./opetussuunnitelmat.vue?vue&type=template&id=38eabb5c&scoped=true&"
import script from "./opetussuunnitelmat.vue?vue&type=script&lang=ts&"
export * from "./opetussuunnitelmat.vue?vue&type=script&lang=ts&"
import style0 from "./opetussuunnitelmat.vue?vue&type=style&index=0&id=38eabb5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eabb5c",
  null
  
)

export default component.exports